import { SYNC } from './actionTypes'

// Actions
export const setSyncStatus = (status) => {
    return {
        type: SYNC.UPDATE_TREE_SYNC_STATUS,
        payload: status
    }
}

export const setSyncd = () => {
    return {
        type: SYNC.UPDATE_TREE_SYNC_STATUS,
        payload: {
            saved: true,
            newChangesOnServer: false,
            lastServerCommunicationTime: new Date().getTime(), // Somebody says its antipattern
            lastNetworkRequestWasOffline: false,
            exportStartTime: undefined
        }
    }
}

export const setSyncHash = (hash) => {
    return {
        type: SYNC.UPDATE_SYNC_HASH,
        payload: hash
    }
}

export const setLastServerCommunicationTime = (timestamp) => {
    return {
        type: SYNC.UPDATE_LAST_SERVER_COMMUNICATION_TIME,
        payload: timestamp
    }
}

export const setLastNetworkRequestWasOffline = (status) => {
    return {
        type: SYNC.UPDATE_LAST_SERVER_COMMUNICATION_TIME,
        payload: status
    }
}

export const setUpdateExportStartTime = (timestamp) => {
    return {
        type: SYNC.UPDATE_EXPORT_START_TIME,
        payload: timestamp
    }
}

// Reducers
const initialState = {
    syncStatus: {
        saved: false,
        newChangesOnServer: true,
        lastServerCommunicationTime: undefined,
        lastNetworkRequestWasOffline: false,
        exportStartTime: undefined
    },
    syncHash: 0
}

export const syncReducer = (state = initialState, action) => {
    const { type, payload } = action

    if (type.startsWith('NODE')) {
        return {
            ...state,
            syncStatus: {
                ...state.syncStatus,
                saved: false
            }
        }
    }

    if (type === SYNC.UPDATE_TREE_SYNC_STATUS) {
        return {
            ...state,
            syncStatus: {
                ...state.syncStatus,
                ...payload
            }
        }
    }

    if (type === SYNC.UPDATE_SYNC_HASH) {
        return {
            ...state,
            syncHash: payload
        }
    }

    if (type === SYNC.UPDATE_EXPORT_START_TIME) {
        return {
            ...state,
            syncStatus: {
                ...state.syncStatus,
                exportStartTime: payload
            }
        }
    }

    if (type === SYNC.UPDATE_LAST_NETWORK_REQUEST_WAS_OFFLINE) {
        return {
            ...state,
            syncStatus: {
                ...state.syncStatus,
                lastNetworkRequestWasOffline: payload
            }
        }
    }

    if (type === SYNC.UPDATE_LAST_SERVER_COMMUNICATION_TIME) {
        return {
            ...state,
            syncStatus: {
                ...state.syncStatus,
                lastServerCommunicationTime: payload
            }
        }
    }

    return state
}

// Selectors
export const selectSyncStatus = (state) => state.sync.syncStatus
export const selectSyncHash = (state) => state.sync.syncHash
export const selectExportStartTime = (state) => state.sync.syncStatus.exportStartTime
